import { checkConnect } from './socketRetranslator';

let sessionSubscriber = null;
let dataSubscriber = null;
let currentSessionId = null;

export const unsubscribeSensors = () => {
  if (sessionSubscriber) {
    sessionSubscriber.unsubscribe();
    sessionSubscriber = null;
  }

  if (dataSubscriber) {
    dataSubscriber.unsubscribe();
    dataSubscriber = null;
  }

  currentSessionId = null;
};

export const subscribeSensors = async ({ vehicleIds = [], sensorIds = [] }, onMessage) => {
  if (!vehicleIds.length || !sensorIds.length) {
    unsubscribeSensors();
    return;
  }

  // чистим старые подписки
  unsubscribeSensors();

  const client = await checkConnect();

  sessionSubscriber = client.subscribe('/topic/sensor-data/subscribe', (frame) => {
    const raw = frame.body;
    const sessionId = raw.replace(/"/g, '');

    if (!sessionId) {
      return;
    }

    currentSessionId = sessionId;

    const dataTopic = `/user/${currentSessionId}/sensor-data/receive`;

    dataSubscriber = client.subscribe(dataTopic, (msg) => {
      try {
        const parsed = JSON.parse(msg.body);
        onMessage(parsed);
      } catch (e) {
        console.error(e);
      }
    });

    sessionSubscriber.unsubscribe();
    sessionSubscriber = null;
  });

  const payload = { vehicleIds, sensorIds };
  client.send('/app/sensor-data/subscribe', JSON.stringify(payload));
};
